





















import { Component, Vue, Prop } from 'vue-property-decorator';
import FrameBox from '@/components/scanner/FrameBox.vue';
import Scanner from '@/components/scanner/Scanner.vue';

@Component ({
    components: {
        FrameBox,
        Scanner,
    }
})
export default class Home extends Vue {
    @Prop({ default: false }) public show!: boolean;
}
